import React from 'react';
import { Flex } from 'antd-mobile';
import Status from '../status/Status';
import { isLiveInProgress, isLiveEnded, isOvertimeEnd } from '../../../../helpers';
import './Headers.css';
import PropTypes from 'prop-types';
import { LOGO_TEAM_URL } from '../../../../config.env';
import _ from 'lodash';

const Headers = props => {
    return (
        <div style={{paddingTop: 29}} className='ls_page_live'>
            <div className='ls_status_live'>
                <Status match={props.match} live={props.live} pageReducer={props.pageReducer} />
            </div>
            <div style={{margin: 'auto', width: '90%'}}>
                <Flex justify='center' align='center' alignContent='center'>
                    <Flex.Item>
                        <div className='team'>
                            <div className='center-align'>
                                <img
                                    style={{width: '50px', borderRadius: '60px', height: '50px'}} 
                                    src={`${LOGO_TEAM_URL}/${props.match.homeTeamClCod}.jpg`} alt='' />
                            </div>
                            <div className="team-name center-align" style={{fontSize: 10}}>{props.match.homeTeam}</div>
                        </div>
                    </Flex.Item>
                    <Flex.Item>
                        <div className="score center-align">{score(props)}</div>
                        {isOvertimeEnd(props.live.actions) && <div style={{marginTop: -10, fontSize: 15, color: '#fff'}} className="center-align">{scoreTab(props.live.actions)}</div>}
                    </Flex.Item>
                    <Flex.Item>
                        <div className='team'>
                            <div className='center-align'>
                                <img
                                    style={{width: '50px', borderRadius: '60px', height: '50px'}} 
                                    src={`${LOGO_TEAM_URL}/${props.match.awayTeamClCod}.jpg`} alt='' />
                            </div>
                            <div className="team-name center-align" style={{fontSize: 10}}>{props.match.awayTeam}</div>
                        </div>
                    </Flex.Item>
                    
                </Flex>
            </div>
        </div>
    )
}

const score = props => isLiveInProgress(props.live) || isLiveEnded(props.live) ? (`${(props.live.score && props.live.score.home !== null) ? props.live.score.home : 0 }:${(props.live.score && props.live.score.away !== null) ? props.live.score.away : 0 }`) : 'VS'

const scoreTab = actions => {
    const tab = _.filter(actions, action => action.data.label === 'tab');
    const last = _.last(tab);

    return last ? `${last.data.score.home} TAB ${last.data.score.away}` : '0 TAB 0'
}

Headers.propTypes = {
    live: PropTypes.object.isRequired,
    match: PropTypes.shape({
        homeTeamClCod: PropTypes.string,
        homeTeam: PropTypes.string,
        awayTeamClCod: PropTypes.string,
        awayTeam: PropTypes.string,
        homeTeamGoals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        awayTeamGoals: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    pageReducer: PropTypes.string.isRequired
}

export default Headers;